import { EnhancementPipelineStatus, ShootingStatus, ShootingType } from '../../../domain/types';
import { Property, Shooting } from '../../../providers/api/dtos';
import { UpsertShootingFormModel } from '../../../shooting/components/upsert-shooting-form/UpsertShootingForm';
import { upsertShootingFormModelToShooting as mapFormModelToShooting } from '../../../shooting/utils';

export { shootingToUpsertShootingFormModel } from '../../../shooting/utils';

export const buildNewShooting = (property: Pick<Property, 'id'>): Shooting => ({
  propertyId: property.id!,
  type: ShootingType.DIRECT,
  dueDate: '',
  projectStatus: ShootingStatus.BOOKED,
  pipelineStatus: EnhancementPipelineStatus.NOT_STARTED,
  files: [],
});

export const upsertShootingFormModelToShooting = (
  formValues: UpsertShootingFormModel,
  existingShooting: Shooting,
  isNew = !existingShooting.id,
): Shooting => {
  let shootingStatus;
  switch (true) {
    // Initial status of an agent shooting
    case isNew && formValues.type === ShootingType.AGENT:
      shootingStatus = ShootingStatus.DELIVERED;
      break;
    // Initial status of a direct/partner shooting
    case isNew && [ShootingType.DIRECT, ShootingType.PARTNER].includes(formValues.type as ShootingType):
      shootingStatus = ShootingStatus.BOOKED;
      break;
    // Reset status in case of agent to direct/partner type change
    case existingShooting.type === ShootingType.AGENT && existingShooting.projectStatus === ShootingStatus.DELIVERED
      && (formValues.type as ShootingType) !== ShootingType.AGENT:
      shootingStatus = ShootingStatus.BOOKED;
      break;
    // Reset status in case of direct/partner to agent type change
    case [ShootingType.DIRECT, ShootingType.PARTNER].includes(existingShooting.type)
      && [ShootingStatus.BOOKED, ShootingStatus.REVIEWED].includes(existingShooting.projectStatus)
      && formValues.type === ShootingType.AGENT:
      shootingStatus = ShootingStatus.DELIVERED;
      break;
    // In all the other cases, we keep the existing status
    default:
      shootingStatus = existingShooting.projectStatus;
      break;
  }

  return {
    ...mapFormModelToShooting(formValues, existingShooting),
    projectStatus: shootingStatus,
  };
};
